import { render } from "./PlaygroundView.vue?vue&type=template&id=392898e1"
import script from "./PlaygroundView.vue?vue&type=script&lang=js"
export * from "./PlaygroundView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\timdi\\Desktop\\funkapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__